import React, { useState } from 'react';
import { Platform, ScrollView, useWindowDimensions, View } from 'react-native';
import { useTheme } from 'react-native-paper';
import { ANDROID_MARKET } from '@env';
import { t, Trans } from '@lingui/macro';

import Button from '@src/components/Button';
import Container from '@src/components/Container';
import CustomSwitch from '@src/components/CustomSwitch';
import Divider from '@src/components/Divider';
import ImageIcon from '@src/components/ImageIcon';
import RadioGroup from '@src/components/Radio';
import Separator from '@src/components/Separator';
import SlideComponent from '@src/components/Slide';
import { Body1 } from '@src/components/Typography';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { SubscriptionId } from '@src/enums';
import { persianNumber } from '@src/helpers';
import { CheckAccess } from '@src/helpers/hasAccessMember';
import useAllStatus from '@src/hooks/useAllStatus';
import useBuyPlans from '@src/hooks/useBuyPlans';
import useBuyPlansCafeBazaar from '@src/hooks/useBuyPlansCafeBazaar';
import useCafeBazaar from '@src/hooks/useCafeBazaar';
import useRefreshPrimeStatus from '@src/hooks/useRefreshPrimeStatus';
import useSnackBar from '@src/hooks/useSnackBar';
import { windowWidth } from '@src/configuration/constants';
import { PrimePlan } from '@src/types';

import PlanWithRadio from './PlanWithRadio';
import {
  BottomButton,
  ContentSubtitle,
  Controls,
  ControlView,
  IconView,
  Plans,
  PrimePlanList,
  RowContainer,
  RowIcons,
  SubtitleComapre,
  TitleCompare,
  SubtitleComapreSmall,
} from './styled';
import { Props } from './types';
import useSlides from './useSlides';

const Screen: React.FC<Props> = ({
  route: {
    params = {
      primeId: undefined,
      result: undefined,
      isImmigration: undefined,
    },
  },
}) => {
  const [activeSlide, setActiveSlide] = React.useState(0);
  const [activeTab, setActiveTab] = React.useState(2);
  const [selPlans, setPlans] = useState<PrimePlan[]>([]);
  const slides = useSlides();
  const { handleSubscribe: handleSubscribeCafeBazaar } = useCafeBazaar();
  const snackBar = useSnackBar();
  const dimensions = useWindowDimensions();
  const { itemWidth, sliderWidth } = React.useMemo(
    () => ({
      itemWidth: dimensions.width - 50,
      sliderWidth: dimensions.width,
    }),
    [dimensions.width]
  );

  const {
    activePlanIndex,
    activePlan,
    handleTypePlan,
    plans,
    handleSnapToPlan,
    payForPrimePlan,
    handleBuyPress,
    calculateIndex,
    // handleBuyPlan,
  } = useBuyPlans(params.primeId, params.result);
  const {
    loading: bazaarLoading,
    makeRequest: payPlanFromCafeBazaar,
  } = useBuyPlansCafeBazaar();
  const refreshPrimeStatus = useRefreshPrimeStatus(true);
  const theme = useTheme();
  // TODO: refactor this to simpler handler
  const buyPrimePlanHandler = async () => {
    if (Platform.OS === 'android') {
      switch (ANDROID_MARKET) {
        case 'cafeBazaar': {
          try {
            const purchaseResult = await handleSubscribeCafeBazaar(
              activePlan.days
            );
            if (purchaseResult) {
              // await handleBuyPlan(activePlan.id);
              await payPlanFromCafeBazaar(
                activePlan.id,
                purchaseResult.packageName,
                purchaseResult.purchaseToken,
                purchaseResult.productId as SubscriptionId
              );
              await refreshPrimeStatus();
            }
          } catch (error) {
            if (error instanceof Error) {
              snackBar.show({ content: error.message });
            } else {
              snackBar.show({ content: error });
            }
          }
          break;
        }

        case 'playStore': {
          await handleBuyPress();
          await refreshPrimeStatus();
          break;
        }

        default:
          await handleBuyPress();
          await refreshPrimeStatus();
          break;
      }
    } else {
      await handleBuyPress();

      await refreshPrimeStatus();
    }
  };
  const accessData = useAllStatus();
  const allStatus = CheckAccess(accessData);
  // React.useEffect(() => {
  //   if (plans?.data) {
  //     if (params.isImmigration) onSelectSwitch(1);
  //     else if (
  //       allStatus !== undefined &&
  //       allStatus[1]?.daysRemaining === 0 &&
  //       allStatus[0]?.daysRemaining !== undefined &&
  //       allStatus[0]?.daysRemaining > 0
  //     )
  //       onSelectSwitch(2);
  //     else onSelectSwitch(1);
  //   }
  // }, [allStatus, plans]);

  React.useEffect(() => {
    if (plans?.data) {
      if (params.isImmigration) {
        onSelectSwitch(1);
      } else if (allStatus === 1) {
        onSelectSwitch(2);
      } else {
        onSelectSwitch(1);
      }
    }
  }, [allStatus, params.isImmigration, plans]);
  const onSelectSwitch = (index: number) => {
    //alert('Selected index: ' + index);

    const plans_ =
      index === 2
        ? plans?.data.filter((e) => e.planType === 'BOOKLET')
        : plans?.data.filter((e) => e.planType === 'PRIME_PLUS');
    setPlans(plans_);
    console.log('onSelectSwitch', index, activeTab);
    setActiveTab(index);
    handleTypePlan(index === 2 ? 'BOOKLET' : 'PRIME_PLUS');
  };

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <ScrollView style={{ paddingBottom: 100 }}>
          <>
            {/* <Slides>
            <PlansCarousel
              firstItem={0}
              initialNumToRender={3}
              data={slides.data}
              itemWidth={itemWidth}
              sliderWidth={sliderWidth}
              onSnapToItem={setActiveSlide}
              renderItem={({ item: { cover } }) => (
                <SlideComponent onPress={() => null} source={cover.source} />
              )}
            />
            <Pagination
              dotsLength={slides.data.length}
              activeDotIndex={activeSlide}
            />
          </Slides> */}
            <Separator />
            <RowIcons margin={true}>
              <ImageIcon
                source={require('@src/assets/images/Subscription.png')}
                size={24}
              />
              <Body1>
                <Trans>Subscription State</Trans>
              </Body1>
              {allStatus === 0 && (
                <ContentSubtitle color={'#403F3F'} weight={700}>
                  <Trans>No Subscription</Trans>
                </ContentSubtitle>
              )}
            </RowIcons>
            {allStatus > 0 && (
              <RowIcons margin={true}>
                {(allStatus === 1 || allStatus === 3) && (
                  <>
                    <Body1>
                      <Trans>Subscription Base</Trans>
                    </Body1>

                    <ContentSubtitle color={'#403F3F'} weight={700}>
                      {': '}
                      {accessData &&
                        accessData[0] &&
                        accessData[0]?.daysRemaining &&
                        persianNumber(
                          accessData[0]?.daysRemaining.toString()
                        )}{' '}
                      <Trans>Remind </Trans>
                    </ContentSubtitle>
                  </>
                )}
                {allStatus === 3 && <Body1>{'  ,  '}</Body1>}
                {(allStatus === 2 || allStatus === 3) && (
                  <>
                    <Body1>
                      <Trans>Subscription Special</Trans>
                    </Body1>
                    <ContentSubtitle color={'#403F3F'} weight={700}>
                      {': '}
                      {accessData &&
                        accessData[1] &&
                        accessData[1]?.daysRemaining &&
                        persianNumber(
                          accessData[1]?.daysRemaining.toString()
                        )}{' '}
                      <Trans>Remind</Trans>
                    </ContentSubtitle>
                  </>
                )}
              </RowIcons>
            )}
            <View style={{ alignItems: 'center', margin: 20 }}>
              <CustomSwitch
                selectionMode={activeTab}
                roundCorner={true}
                option1={'Base'}
                option2={`Specific`}
                onSelectSwitch={onSelectSwitch}
                selectionColor={'#FFD700'}
              />
            </View>

            {plans.loading ? null : (
              <PrimePlanList
                showsHorizontalScrollIndicator={false}
                extraData={0}
                data={selPlans ? selPlans : []}
                renderItem={({ item, index }) => {
                  const newIndex = calculateIndex(index);

                  return (
                    <PlanWithRadio
                      ActiveTab={activeTab}
                      active={activePlanIndex === newIndex}
                      data={item}
                      onPress={() => handleSnapToPlan(newIndex)}
                    />
                  );
                }}
              />
            )}

            <Controls>
              <Divider horizontalPadding={32} />
              <ControlView>
                <ContentSubtitle>
                  <Trans>
                    if you are not satisfied with youtopin prime product or
                    service, a refund will be made
                  </Trans>
                </ContentSubtitle>
              </ControlView>
              <Divider horizontalPadding={32} />
              <RowContainer>
                <TitleCompare>
                  <Trans>Compare Subscription</Trans>
                </TitleCompare>
                <RowIcons>
                  <IconView
                    margin={12}
                    isSmall={windowWidth < 330 ? true : false}
                  >
                    <TitleCompare>
                      <Trans>Specific</Trans>
                    </TitleCompare>
                  </IconView>
                  <IconView
                    margin={12}
                    isSmall={windowWidth < 330 ? true : false}
                  >
                    <TitleCompare>
                      <Trans>Base</Trans>
                    </TitleCompare>
                  </IconView>
                </RowIcons>
              </RowContainer>

              <RowContainer>
                {windowWidth > 330 ? (
                  <SubtitleComapre>
                    <Trans>Access To Immigration Guides</Trans>
                  </SubtitleComapre>
                ) : (
                  <SubtitleComapreSmall>
                    <Trans>Access To Immigration Guides</Trans>
                  </SubtitleComapreSmall>
                )}
                <RowIcons>
                  <IconView
                    margin={12}
                    isSmall={windowWidth < 330 ? true : false}
                  >
                    <ImageIcon
                      source={require('@src/assets/images/tick_noborder.png')}
                      size={16}
                    />
                  </IconView>
                  <IconView
                    margin={12}
                    isSmall={windowWidth < 330 ? true : false}
                  >
                    <ImageIcon
                      source={require('@src/assets/images/close-square.png')}
                      size={16}
                    />
                  </IconView>
                </RowIcons>
              </RowContainer>

              <RowContainer>
                {windowWidth > 330 ? (
                  <SubtitleComapre>
                    <Trans>Access To Trip guides</Trans>
                  </SubtitleComapre>
                ) : (
                  <SubtitleComapreSmall>
                    <Trans>Access To Trip guides</Trans>
                  </SubtitleComapreSmall>
                )}

                <RowIcons>
                  <IconView
                    margin={12}
                    isSmall={windowWidth < 330 ? true : false}
                  >
                    <ImageIcon
                      source={require('@src/assets/images/tick_noborder.png')}
                      size={16}
                    />
                  </IconView>
                  <IconView
                    margin={12}
                    isSmall={windowWidth < 330 ? true : false}
                  >
                    <ImageIcon
                      source={require('@src/assets/images/tick_noborder.png')}
                      size={16}
                    />
                  </IconView>
                </RowIcons>
              </RowContainer>

              <RowContainer>
                {windowWidth > 330 ? (
                  <SubtitleComapre>
                    <Trans>Iran Tours Discount</Trans>
                  </SubtitleComapre>
                ) : (
                  <SubtitleComapreSmall>
                    <Trans>Iran Tours Discount</Trans>
                  </SubtitleComapreSmall>
                )}

                <RowIcons>
                  <IconView
                    margin={12}
                    isSmall={windowWidth < 330 ? true : false}
                  >
                    <ImageIcon
                      source={require('@src/assets/images/tick_noborder.png')}
                      size={16}
                    />
                  </IconView>
                  <IconView
                    margin={12}
                    isSmall={windowWidth < 330 ? true : false}
                  >
                    <ImageIcon
                      source={require('@src/assets/images/tick_noborder.png')}
                      size={16}
                    />
                  </IconView>
                </RowIcons>
              </RowContainer>
            </Controls>
          </>
        </ScrollView>
        <BottomButton>
          <Button
            width={328}
            mode="contained"
            onPress={buyPrimePlanHandler}
            loading={payForPrimePlan.loading || bazaarLoading}
            disabled={payForPrimePlan.loading || bazaarLoading}
          >
            <Trans>Buy Subscription</Trans>
          </Button>
        </BottomButton>
      </Container>
    </>
  );
};

Screen.displayName = 'PrimePlans';

export default React.memo(Screen);
